import { render } from "./hospUserView.vue?vue&type=template&id=7d897161&scoped=true"
import script from "./hospUserView.vue?vue&type=script&lang=js"
export * from "./hospUserView.vue?vue&type=script&lang=js"

import "./hospUserView.vue?vue&type=style&index=0&id=7d897161&scoped=true&lang=css"

import exportComponent from "/Users/baojian/Documents/anyway/anyway-wx/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d897161"]])

export default __exports__